// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars */
import React, { useState, useEffect } from "react";
import { 
  Search, 
  Plus, 
  Edit2, 
  Trash2, 
  X, 
  FileText,
  Loader2,
  ChevronLeft,
  ChevronRight
} from "lucide-react";

// IMPORTAÇÕES DO FIREBASE
import { collection, addDoc, updateDoc, deleteDoc, doc, onSnapshot, serverTimestamp, query } from "firebase/firestore";
import { db } from "../../config/firebase";

const AdminModelosParecerPage = () => {
  // 🟢 Tipagem para blindar o TypeScript
  const [modelos, setModelos] = useState(/** @type {any[]} */ ([]));
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  // 🟢 States de Paginação (Client-Side)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Estados do Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    nome: "",
    titulo: "",
    descricao: ""
  });
  
  const brandColor = "#00a99d";

  // 🚀 EFEITO PARA TRAVAR O SCROLL DA PÁGINA QUANDO O MODAL ESTIVER ABERTO
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isModalOpen]);

  // ==========================================
  // 1. BUSCAR MODELOS (Tempo Real Seguro)
  // ==========================================
  useEffect(() => {
    const q = query(collection(db, "parecer_templates"));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const modelosData = snapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          nome: data.nome || "",
          titulo: data.titulo || "",
          descricao: data.descricao || "",
          ...data
        };
      });

      modelosData.sort((a, b) => a.nome.localeCompare(b.nome));

      setModelos(modelosData);
      setLoading(false);
    }, (error) => {
      console.error("Erro ao buscar modelos de parecer:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // 🟢 Reseta a página para 1 se pesquisar ou mudar a qtde de itens
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);

  // ==========================================
  // 2. FUNÇÕES DO MODAL E FORMULÁRIO
  // ==========================================
  const handleOpenModal = (modelo = null) => {
    if (modelo) {
      setEditingId(modelo.id);
      setFormData({
        nome: modelo.nome || "",
        titulo: modelo.titulo || "",
        descricao: modelo.descricao || ""
      });
    } else {
      setEditingId(null);
      setFormData({ nome: "", titulo: "", descricao: "" });
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingId(null);
    setFormData({ nome: "", titulo: "", descricao: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // ==========================================
  // 3. AÇÕES DE BANCO DE DADOS (CRUD)
  // ==========================================
  const handleSave = async (e) => {
    e.preventDefault();
    if (!formData.nome || !formData.descricao) {
      alert("Os campos Nome e Descrição são obrigatórios.");
      return;
    }

    setIsUpdating(true);
    try {
      if (editingId) {
        // ATUALIZAR
        const docRef = doc(db, "parecer_templates", editingId);
        await updateDoc(docRef, {
          ...formData,
          updatedAt: serverTimestamp()
        });
      } else {
        // CRIAR NOVO
        await addDoc(collection(db, "parecer_templates"), {
          ...formData,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
      }
      handleCloseModal();
    } catch (error) {
      console.error("Erro ao salvar modelo:", error);
      alert("Falha ao salvar o modelo. Verifique o console.");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDelete = async (id, nome) => {
    const confirmar = window.confirm(`Tem certeza que deseja excluir o modelo "${nome}"? Esta ação não pode ser desfeita e ele sumirá das opções de resposta.`);
    if (!confirmar) return;

    setIsUpdating(true);
    try {
      await deleteDoc(doc(db, "parecer_templates", id));
    } catch (error) {
      console.error("Erro ao excluir modelo:", error);
      alert("Falha ao excluir o modelo.");
    } finally {
      setIsUpdating(false);
    }
  };

  // ==========================================
  // 4. FILTRO E PAGINAÇÃO
  // ==========================================
  const modelosFiltrados = modelos.filter(modelo => 
    (modelo.nome && modelo.nome.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (modelo.titulo && modelo.titulo.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (modelo.descricao && modelo.descricao.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // 🟢 Fatiamento da Paginação
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = modelosFiltrados.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(modelosFiltrados.length / itemsPerPage);

  const nextPage = () => { if (currentPage < totalPages) setCurrentPage(prev => prev + 1); };
  const prevPage = () => { if (currentPage > 1) setCurrentPage(prev => prev - 1); };

  // ============================================================================
  // SKELETON LOADER (Suporte a Dark Mode e Responsivo)
  // ============================================================================
  if (loading) {
    return (
      <div className="p-4 sm:p-6 lg:p-8 space-y-6 animate-pulse bg-light-bg dark:bg-dark-bg min-h-screen">
        <div className="flex items-center gap-4 border-b border-light-border dark:border-dark-border pb-6">
           <div className="w-14 h-14 bg-slate-200 dark:bg-slate-800 rounded-xl shrink-0"></div>
           <div className="space-y-2"><div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-64"></div><div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-96 hidden md:block"></div></div>
        </div>

        <div className="hidden md:block bg-light-card dark:bg-dark-card rounded-2xl border border-light-border dark:border-dark-border overflow-hidden mt-6">
          <div className="bg-light-bg/50 dark:bg-dark-bg/50 border-b border-light-border dark:border-dark-border h-14"></div>
          {Array(5).fill(0).map((_, i) => (
            <div key={i} className="flex justify-between items-center p-6 border-b border-light-border dark:border-dark-border">
              <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-48"></div>
              <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-32"></div>
              <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-64"></div>
              <div className="flex gap-2"><div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-8"></div><div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-8"></div></div>
            </div>
          ))}
        </div>

        <div className="md:hidden flex flex-col gap-4 mt-6">
          {Array(3).fill(0).map((_, i) => (
            <div key={i} className="bg-light-card dark:bg-dark-card rounded-2xl p-5 border border-light-border dark:border-dark-border h-48"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6 animate-fade-in bg-light-bg dark:bg-dark-bg min-h-full font-sans relative">
      
      {/* OVERLAY DE LOADING PARA AÇÕES */}
      {isUpdating && (
        <div className="absolute inset-0 bg-light-bg/50 dark:bg-dark-bg/50 backdrop-blur-[2px] z-[50] flex items-center justify-center rounded-2xl">
          <Loader2 className="w-8 h-8 text-brand-primary animate-spin" />
        </div>
      )}

      {/* CABEÇALHO: PADRÃO REAL BENEFÍCIOS */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 border-b border-light-border dark:border-dark-border pb-6">
        
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-teal-50 dark:bg-teal-900/20 flex items-center justify-center shrink-0 border border-teal-100/50 dark:border-teal-800/30">
            <FileText className="w-6 h-6 md:w-7 md:h-7" style={{ color: brandColor }} />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 dark:text-white">
              Modelos de Pareceres
            </h1>
            <p className="text-sm sm:text-base text-slate-500 dark:text-slate-400 mt-0.5">
              Gerencie as respostas padronizadas para agilizar as análises.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row w-full md:w-auto items-center gap-4 mt-2 md:mt-0">
          {/* BARRA DE PESQUISA */}
          <div className="relative w-full sm:w-64">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-4 w-4 text-slate-400" />
            </div>
            <input
              type="text"
              placeholder="Pesquisar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="block w-full pl-10 pr-3 py-2.5 md:py-2 border border-light-border dark:border-dark-border rounded-xl md:rounded-lg leading-5 bg-light-card dark:bg-dark-card text-light-text-primary dark:text-dark-text-primary placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors shadow-sm"
            />
          </div>

          {/* BOTÃO NOVO MODELO */}
          <button
            onClick={() => handleOpenModal()}
            style={{ backgroundColor: brandColor }}
            className="w-full sm:w-auto flex items-center justify-center gap-2 text-white px-6 py-3 md:py-2.5 rounded-xl font-bold text-sm transition-all shadow-md hover:brightness-110 shrink-0"
          >
            <Plus className="w-4 h-4" /> Novo modelo
          </button>
        </div>
      </div>

      {/* ÁREA DE LISTAGEM - MUTAÇÃO (TABELA DESKTOP / CARDS MOBILE) */}
      <div className="bg-light-bg md:bg-light-card dark:bg-dark-bg md:dark:bg-dark-card md:rounded-2xl md:border md:border-light-border md:dark:border-dark-border shadow-none md:shadow-sm overflow-hidden flex flex-col">
        {modelosFiltrados.length === 0 ? (
          <div className="flex flex-col items-center justify-center p-12 text-center bg-light-card dark:bg-dark-card rounded-2xl border border-light-border dark:border-dark-border">
            <div className="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4">
              <FileText className="w-8 h-8 text-slate-400" />
            </div>
            <h3 className="text-lg font-bold text-light-text-primary dark:text-dark-text-primary mb-1">Nenhum modelo encontrado</h3>
            <p className="text-light-text-secondary text-sm">
              {searchTerm ? "Tente ajustar sua pesquisa." : "Clique em 'Novo modelo' para cadastrar sua primeira resposta padrão."}
            </p>
          </div>
        ) : (
          <>
            {/* VIEW DESKTOP: TABELA */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full text-left text-sm whitespace-nowrap md:whitespace-normal">
                <thead className="bg-slate-200/50 dark:bg-slate-800/50 text-light-text-secondary dark:text-dark-text-secondary font-bold uppercase text-[11px] tracking-wider border-b border-light-border dark:border-dark-border">
                  <tr>
                    <th className="px-6 py-4">Nome</th>
                    <th className="px-6 py-4">Título</th>
                    <th className="px-6 py-4">Descrição</th>
                    <th className="px-6 py-4 text-center w-24">Ações</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-light-border dark:divide-dark-border">
                  {currentItems.map((modelo) => (
                    <tr key={`desktop-${modelo.id}`} className="hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-colors group">
                      <td className="px-6 py-4 font-bold text-light-text-primary dark:text-dark-text-primary">
                        {modelo.nome}
                      </td>
                      <td className="px-6 py-4 text-light-text-secondary dark:text-slate-300">
                        {modelo.titulo || "-"}
                      </td>
                      <td className="px-6 py-4 text-light-text-secondary dark:text-slate-300 max-w-md truncate" title={modelo.descricao}>
                        {modelo.descricao}
                      </td>
                      <td className="px-6 py-4 text-center">
                        <div className="flex items-center justify-center gap-3 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
                          <button 
                            onClick={() => handleOpenModal(modelo)}
                            className="text-slate-400 hover:text-brand-primary transition-colors p-1"
                            title="Editar Modelo"
                          >
                            <Edit2 className="w-4 h-4" />
                          </button>
                          <button 
                            onClick={() => handleDelete(modelo.id, modelo.nome)}
                            className="text-slate-400 hover:text-red-500 transition-colors p-1"
                            title="Excluir Modelo"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* VIEW MOBILE: CARDS MUTANTES */}
            <div className="md:hidden flex flex-col gap-4">
              {currentItems.map((modelo) => (
                <div key={`mobile-${modelo.id}`} className="bg-light-card dark:bg-dark-card rounded-2xl p-5 border border-light-border dark:border-dark-border shadow-sm flex flex-col gap-3">
                  
                  {/* Cabeçalho do Card */}
                  <div>
                    <span className="text-[10px] font-black uppercase text-brand-primary tracking-wider">Identificador</span>
                    <h3 className="font-bold text-light-text-primary dark:text-dark-text-primary text-base leading-tight mt-0.5">
                      {modelo.nome}
                    </h3>
                  </div>

                  {/* Título (se houver) */}
                  {modelo.titulo && (
                    <div>
                      <span className="text-[10px] font-black uppercase text-slate-400 tracking-wider">Título do E-mail</span>
                      <p className="text-sm font-medium text-light-text-secondary dark:text-slate-300 mt-0.5">
                        {modelo.titulo}
                      </p>
                    </div>
                  )}

                  {/* Descrição (Truncada em 3 linhas) */}
                  <div>
                    <span className="text-[10px] font-black uppercase text-slate-400 tracking-wider">Descrição</span>
                    <p className="text-sm text-light-text-secondary dark:text-slate-400 mt-0.5 line-clamp-3 italic bg-slate-50 dark:bg-slate-800/50 p-3 rounded-xl border border-slate-100 dark:border-slate-700/50">
                      "{modelo.descricao}"
                    </p>
                  </div>

                  {/* Ações (Fat Fingers) */}
                  <div className="flex items-center gap-2 mt-2 pt-4 border-t border-light-border dark:border-dark-border">
                    <button 
                      onClick={() => handleOpenModal(modelo)}
                      className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 rounded-xl font-bold text-xs hover:bg-slate-200 transition-colors border border-slate-200 dark:border-slate-700"
                    >
                      <Edit2 className="w-3.5 h-3.5" /> Editar
                    </button>
                    <button 
                      onClick={() => handleDelete(modelo.id, modelo.nome)}
                      className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-red-50 dark:bg-red-900/10 text-red-600 dark:text-red-400 rounded-xl font-bold text-xs hover:bg-red-100 transition-colors border border-red-200 dark:border-red-900/30"
                    >
                      <Trash2 className="w-3.5 h-3.5" /> Excluir
                    </button>
                  </div>

                </div>
              ))}
            </div>

            {/* 🟢 RODAPÉ DE PAGINAÇÃO GLOBAL (Desktop & Mobile) */}
            <div className="p-4 border-t border-light-border dark:border-dark-border bg-light-bg/50 dark:bg-dark-bg/50 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-light-text-secondary dark:text-dark-text-secondary shrink-0">
              <span className="font-medium text-center md:text-left">
                Mostrando <strong className="text-light-text-primary dark:text-dark-text-primary">{indexOfFirstItem + 1}</strong> a <strong className="text-light-text-primary dark:text-dark-text-primary">{Math.min(indexOfLastItem, modelosFiltrados.length)}</strong> de <strong className="text-light-text-primary dark:text-dark-text-primary">{modelosFiltrados.length}</strong> modelos
              </span>
              
              <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto">
                <div className="flex items-center gap-2 bg-light-card dark:bg-dark-card px-3 py-1.5 rounded-lg border border-light-border dark:border-dark-border shadow-sm w-full sm:w-auto justify-center">
                  <span className="font-medium">Itens:</span>
                  <select 
                    value={itemsPerPage}
                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    className="bg-transparent border-none font-bold text-brand-primary focus:ring-0 cursor-pointer text-sm outline-none"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>

                {totalPages > 1 && (
                  <div className="flex items-center gap-2 justify-center w-full sm:w-auto">
                    <button 
                      onClick={prevPage}
                      disabled={currentPage === 1}
                      className="p-1.5 rounded-lg border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card hover:bg-light-bg dark:hover:bg-dark-bg disabled:opacity-50 transition-colors shadow-sm text-light-text-secondary dark:text-dark-text-secondary"
                    >
                      <ChevronLeft className="w-5 h-5" />
                    </button>
                    <span className="text-sm font-bold text-light-text-primary dark:text-dark-text-primary px-3 py-1 bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border rounded-lg shadow-sm">
                      {currentPage} / {totalPages}
                    </span>
                    <button 
                      onClick={nextPage}
                      disabled={currentPage >= totalPages}
                      className="p-1.5 rounded-lg border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card hover:bg-light-bg dark:hover:bg-dark-bg disabled:opacity-50 transition-colors shadow-sm text-light-text-secondary dark:text-dark-text-secondary"
                    >
                      <ChevronRight className="w-5 h-5" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {/* ==============================================================
          MODAL DE CRIAÇÃO / EDIÇÃO DE MODELO
          ============================================================== */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-8 animate-fade-in overflow-hidden">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={handleCloseModal}></div>
          <div className="relative bg-light-card dark:bg-dark-card w-full max-w-2xl flex flex-col rounded-2xl shadow-2xl overflow-hidden border border-light-border dark:border-dark-border max-h-full">
            
            {/* CABEÇALHO DO MODAL */}
            <div className="p-5 sm:p-6 border-b border-light-border dark:border-dark-border flex justify-between items-center bg-slate-50 dark:bg-slate-800/50 shrink-0">
              <h2 className="text-xl font-bold flex items-center gap-2 text-brand-primary">
                {editingId ? <Edit2 className="w-5 h-5"/> : <Plus className="w-5 h-5"/>}
                {editingId ? 'Editar Modelo de Parecer' : 'Novo Modelo de Parecer'}
              </h2>
              <button onClick={handleCloseModal} className="text-slate-400 hover:text-slate-600 p-2 bg-slate-200 dark:bg-slate-700 rounded-full transition-colors">
                <X className="w-5 h-5"/>
              </button>
            </div>

            {/* CORPO DO FORMULÁRIO */}
            <form id="modeloForm" onSubmit={handleSave} className="p-5 sm:p-6 flex-1 min-h-0 overflow-y-auto space-y-5 bg-light-bg dark:bg-dark-bg custom-scrollbar">
              
              <div>
                <label className="block text-xs font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider mb-1">
                  Nome (Identificador) <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="nome"
                  required
                  value={formData.nome}
                  onChange={handleInputChange}
                  placeholder="Ex: FALTA DOCUMENTO, RENDA INSUFICIENTE..."
                  className="w-full px-4 py-2.5 bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-brand-primary/50 text-light-text-primary dark:text-dark-text-primary uppercase"
                />
              </div>

              <div>
                <label className="block text-xs font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider mb-1">
                  Título do Email / Resumo
                </label>
                <input
                  type="text"
                  name="titulo"
                  value={formData.titulo}
                  onChange={handleInputChange}
                  placeholder="Ex: Solicitação de Documentos"
                  className="w-full px-4 py-2.5 bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-brand-primary/50 text-light-text-primary dark:text-dark-text-primary"
                />
              </div>

              <div>
                <label className="block text-xs font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider mb-1">
                  Descrição / Texto do Parecer <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="descricao"
                  required
                  value={formData.descricao}
                  onChange={handleInputChange}
                  placeholder="Digite o texto padronizado que será enviado para a imobiliária..."
                  className="w-full h-40 px-4 py-3 bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-brand-primary/50 text-light-text-primary dark:text-dark-text-primary resize-none"
                ></textarea>
                <p className="text-[10px] text-light-text-secondary mt-2 flex items-center gap-1">
                  Este é o texto que será injetado automaticamente na área de resposta durante a análise.
                </p>
              </div>

            </form>

            {/* RODAPÉ DO MODAL */}
            <div className="p-5 sm:p-6 border-t border-light-border dark:border-dark-border bg-slate-50 dark:bg-slate-800/30 flex justify-end gap-3 shrink-0">
              <button 
                type="button" 
                onClick={handleCloseModal} 
                className="px-6 py-2.5 text-sm font-bold text-slate-500 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-full transition-colors border border-transparent"
              >
                Cancelar
              </button>
              <button 
                type="submit" 
                form="modeloForm"
                disabled={isUpdating}
                className="px-6 py-2.5 text-sm font-bold bg-brand-primary text-white rounded-full transition-colors shadow-md hover:bg-teal-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {isUpdating ? <Loader2 className="w-4 h-4 animate-spin"/> : null}
                Salvar Modelo
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default AdminModelosParecerPage;